import CreateNotifySetting from "../components/CreateNotifySetting";
import useCreateSettingNotify from "../hooks/useCreateSettingNotify";

const CreateNotifySettingPage = () => {
    const useCreateSettingNotifyProps = useCreateSettingNotify();
    return (
        <CreateNotifySetting {...useCreateSettingNotifyProps} />
    )
}

export default CreateNotifySettingPage;